  /*============Edit Address Controller
   ================================*/
  angular
  .module('vppApp')
  .controller('editAddressController', editAddressController);

  editAddressController.$inject = ['$scope', '$rootScope', '$state', 'apiFactory', '$timeout', 'AuthenticationService', 'CustomerService'];

  function editAddressController($scope, $rootScope, $state, apiFactory, $timeout, AuthenticationService, CustomerService) {


    if ($rootScope.accountAudit === true) {

      $timeout(function () {
        /* make sure the user can access */
        if (AuthenticationService.isAuthenticated()) {

          /* get user data */
          var cd = CustomerService.getCustomerData();
          $scope.firstName = cd.customer.firstName;
          $scope.lastName = cd.customer.lastName;
          $scope.address1 = cd.customer.address1;
          $scope.address2 = cd.customer.address2;
          $scope.city = cd.customer.city;
          $scope.state = cd.customer.state;
          $scope.zipCode = cd.customer.zipCode;
          $scope.country = 'US';



          /* matches 2 digit State code to selected item */
          var matchState = $scope.state;
          $('#state option').filter(function () {
            return this.value.indexOf(matchState) > -1;
          }).prop('selected', true);
        }
      }, 1000);

    } else {
      $state.transitionTo('view-auth');
    }

    $scope.editAddressCancel = function () {
      var accountId = AuthenticationService.getAuthenticatedID();
      var status = {
        "auditAction": "editcancelled"
      };
      apiFactory.auditAction(accountId, status)
      .then(function successAuditAction(response) {
        $state.go("account-audit");
      }, function errorCallback(response) {
        //console.log(response);
        $scope.serverError = response.data.errors;
      });
    };

    $scope.updateAddress = function () {

      var accountId = AuthenticationService.getAuthenticatedID();
      /* assemble address object to send */
      var address = {
        "addressLine1": $scope.address1,
        "addressLine2": $scope.address2 || '',
        "city": $scope.city,
        "state": $scope.state,
        "zipCode": $scope.zipCode,
        "country": $scope.country
      };

      var status = {
        "auditAction": "editsuccessful"
      };
      apiFactory.updateUserAddress(accountId, address)
      .then(function successUpdateUserAddress(response) {
        // Audit Call w/success
        delete $rootScope.accountAudit;   
        $scope.updateUserInformation();
        apiFactory.auditAction(accountId, status)
        .then(function successauditAction(response) {
        }, function errorCallback(response) {
          $scope.serverError = response.data.errors;
        });
      }, function errorCallback(response2) {
        //console.log(response2);
        $scope.serverError = response2.data.errors;
      });
    };

    /* used to repopulate the 'view-auth' view once you verify address is accurate.*/
    $scope.updateUserInformation = function () {
      var accountId = AuthenticationService.getAuthenticatedID();
      apiFactory.getCustomer(accountId)
      .then(function successGetCustomer(response) {
        CustomerService.setCustomer(response);
        $state.go('view-auth');
      }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
      });
    };



  }
  ;